import { gql } from '@apollo/client';
import { useCallback } from 'react';
import { useQueryWithSimpleErrorHandling } from 'hooks';
import { useOidcUser } from '@axa-fr/react-oidc';
import { getOidcConfigName } from 'utils/functions';

export const USER_DATA_QUERY = gql`
  query authUserData($externalUserId: String) {
    authUserData(externalUserId: $externalUserId) {
      userId
      userName
      hasAccess
      documentRights {
        documentTypeId
        documentStatesIds
      }
      person {
        personId
        lastName
        firstName
        e_Mail
        positionName
        mobilePhone
      }
      userGroups {
        userGroupId
        userGroupName
        isAdmin
      }
      authorizations
      userAdditionalData {
        userId
        avatar
      }
    }
  }
`;

export function useAuthUserData() {
  const { oidcUser } = useOidcUser(getOidcConfigName());

  const externalUserId = oidcUser?.sub;

  const { data: userData, loading } = useQueryWithSimpleErrorHandling(USER_DATA_QUERY, {
    variables: { externalUserId },
    skip: !externalUserId
  });

  const authUser = userData?.authUserData;

  const hasRightToEditDocument = useCallback(
    (documentTypeId, documentStateId) => {
      const documentRights = userData?.authUserData?.documentRights;
      if (!documentRights) return false;

      const documentTypeRights = documentRights.find(x => x.documentTypeId === documentTypeId);
      if (!documentTypeRights) return false;
      return (
        documentTypeRights.documentStatesIds &&
        documentTypeRights.documentStatesIds.length > 0 &&
        documentTypeRights.documentStatesIds.includes(documentStateId)
      );
    },
    [userData]
  );

  return { authUser, loading, hasRightToEditDocument };
}
